export default __webpack_public_path__ + "static/media/feedback_mobile.56faec7e.svg";